/**
 * Formats a phone number string into (xxx) xxx-xxxx format
 * If the input doesn't match expected format, returns the original string
 * 
 * @param value The phone number to format
 * @returns Formatted phone number string
 */
export const formatPhoneNumber = (value: string): string => {
  // Remove all non-digit characters
  const phoneDigits = value.replace(/\D/g, '')
  
  // Return original value if not enough digits
  if (phoneDigits.length < 10) {
    return value
  }
  
  // Format as (xxx) xxx-xxxx
  const areaCode = phoneDigits.slice(0, 3)
  const firstPart = phoneDigits.slice(3, 6)
  const lastPart = phoneDigits.slice(6, 10)
  
  return `(${areaCode}) ${firstPart}-${lastPart}`
}